/** @jsxImportSource @emotion/react */
import React from 'react'
import { FaqsForm, FaqsPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/FaqsContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, faqsManagement } = breadcrumbItems

const FaqsCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <FaqsForm />
        </div>
        <div css={styles.right}>
          <FaqsPreview />
        </div>
      </div>
    </Provider>
  )
}

export default FaqsCreate;
